import { render, staticRenderFns } from "./SetForm.vue?vue&type=template&id=0bcdb63a&scoped=true&"
import script from "./SetForm.vue?vue&type=script&lang=js&"
export * from "./SetForm.vue?vue&type=script&lang=js&"
import style0 from "./SetForm.vue?vue&type=style&index=0&id=0bcdb63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcdb63a",
  null
  
)

export default component.exports